import React from "react";
import MuiFormHelperText, {
  FormHelperTextProps,
} from "@mui/material/FormHelperText";

import { useFormHelperTextStyles } from "./FormHelperText.styles";

function FormHelperText(props: FormHelperTextProps) {
  const formHelperTextClasses = useFormHelperTextStyles();

  return <MuiFormHelperText {...props} classes={formHelperTextClasses} />;
}

export default FormHelperText;
